import { AiChatProps, ChatMessage } from '@components/ai-input-assist/types';

import { request } from '../request';

export const sendChat = async (props: AiChatProps) => {
  const response = await request.post<ChatMessage>(`v1/ai-content-assistant/chat/`, {
    history: props.history,
    variableMap: props.variableMap,
    threadInstructions: props.threadInstructions,
    websocketId: props.websocketId,
  });
  return response.data;
};
